export default () => ({
  trigger: {
    name: 'web.not_found',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: '404_page',
      },
    },
    nonInt: true,
  },
});
